<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Support Centre">
        <base-button exact icon-right="plus" secondary :to="{ name: 'support-centre.create' }">
          New Article
        </base-button>
      </hero-header>
    </template>

    <div class="my-4 py-4">
      <support-article-filter />
    </div>
  </base-content>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'
import SupportArticleFilter from '@/components/SupportArticleFilter.vue'

export default {
  components: {
    HeroHeader,
    SupportArticleFilter
  }
}
</script>
